// @flow
import React from 'react';
import ContentModule from './ContentModule';
import AppIcons from './AppIcons';
import SmsLinkForm from '../Form/SmsLinkForm';

import '../../../static/scss/components/downloadApp.scss';

const title = "UK's favourite";

type Props = { name?: string };

const AppFeature = ({ name = 'London' }: Props) => {
  return (
    <ContentModule baseClassName="downloadApp">
      <div className="c-downloadApp__left">
        <h2>
          Download the <span>{title}</span> parking app
        </h2>
        <p>
          Rated 5 stars with an average satisfaction rating of 96%, JustPark is
          the UK’s favourite parking service. But don’t just take our word for
          it – check out some of the latest customer reviews below for our{' '}
          {name} parking spaces.
        </p>
        <SmsLinkForm name={name} />
        <AppIcons
          baseClassName="c-downloadApp__appIcons"
          modifier="AppFeature"
        />
      </div>
    </ContentModule>
  );
};

export default AppFeature;
